export default "__VITE_ASSET___Ub5OTW4__"